/* eslint-disable global-require */
export const translationResources = {
  'en-US': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/en/wpg.json')
  },
  'en-GB': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/en/wpg.json')
  },
  'pl-PL': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/pl-PL/wpg.json')
  },
  'pt-BR': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/pt-BR/wpg.json')
  },
  'fr-CA': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/fr-CA/wpg.json')
  },
  'es-ES': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/es-ES/wpg.json')
  },
  'de-DE': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/de-DE/wpg.json')
  },
  'zh-Hans': {
    workplaceGiving: require('@percent/workplace-giving/i18n/data/zh-CN/wpg.json')
  }
}
